module.exports = __webpack_public_path__ + "img/9791156330479.eb2ade1d.jpg";